import React from 'react';

export default function useRafLoop(callback) {
  const raf = React.useRef(null)
  const [isActive, setIsActive] = React.useState(true)

  const loopStep = React.useCallback(() => {
    callback();
    raf.current = requestAnimationFrame(loopStep);
  }, [callback]);

  const stop = React.useCallback(() => {
    setIsActive(false);
  }, []);

  const start = React.useCallback(() => {
    setIsActive(true);
  }, []);

  const clear = React.useCallback(() => {
    if (raf.current) {
      cancelAnimationFrame(raf.current);
    }
  }, []);

  React.useEffect(() => clear, [clear]);

  React.useEffect(() => {
    clear();
    if (isActive) {
      raf.current = requestAnimationFrame(loopStep);
    }

    return clear;
  }, [isActive, callback, loopStep, clear]);

  return [start, stop, isActive];
}
